import React, { useState } from 'react';
import { useLocation, useNavigate, Navigate } from 'react-router-dom';
import styled from 'styled-components';
import ChatInterface from '../components/ChatInterface';
import FeedbackDisplay from '../components/FeedbackDisplay';
import { useApiKey } from '../context/ApiKeyContext';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background-color: #f8f9fa;
`;

const ChatPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setTrialBlock } = useApiKey();
  const [showFeedback, setShowFeedback] = useState(false);
  const [conversation, setConversation] = useState([]);
  // How the conversation ended, when it ended on its own. Null if the user
  // pressed End, which carries no in-fiction reason.
  const [conclusion, setConclusion] = useState(null);
  // Identifies this conversation to the trial proxy so it counts as one of the
  // free chats (and its feedback call doesn't count as a separate one). A new
  // id is minted for each "Try Again", which is a fresh conversation.
  const [conversationId, setConversationId] = useState(() => crypto.randomUUID());

  // The scenario and generated partner come from the picker via router state.
  const { scenario, character, realistic } = location.state || {};

  // If opened directly / refreshed (state lives only in history, not the URL),
  // send the user back to the entry screen.
  if (!scenario || !character) {
    return <Navigate to="/" replace />;
  }

  const handleEndChat = (messages, endedWith) => {
    setConversation(messages);
    setConclusion(endedWith || null);
    setShowFeedback(true);
  };

  // The trial hit a wall (exhausted or owner out of credits): record why and
  // send the user home, where the appropriate screen is shown.
  const handleTrialBlocked = (reason) => {
    setTrialBlock(reason);
    navigate('/');
  };

  const handleStartOver = () => {
    navigate('/');
  };

  const handleTryAgain = () => {
    setShowFeedback(false);
    setConversation([]);
    setConclusion(null);
    setConversationId(crypto.randomUUID());
  };

  return (
    <Container>
      {showFeedback ? (
        <FeedbackDisplay
          conversation={conversation}
          character={character}
          scenario={scenario}
          conclusion={conclusion}
          conversationId={conversationId}
          onStartOver={handleStartOver}
          onTryAgain={handleTryAgain}
          onTrialBlocked={handleTrialBlocked}
        />
      ) : (
        <ChatInterface
          key={conversationId}
          scenario={scenario}
          character={character}
          realistic={realistic}
          conversationId={conversationId}
          onEndChat={handleEndChat}
          onTrialBlocked={handleTrialBlocked}
        />
      )}
    </Container>
  );
};

export default ChatPage;
